import React from 'react';
import SEO from '../components/SEO';
import './StaticPage.css';

const AboutPage = () => (
  <div className="static-page">
    <SEO
      title="About Us"
      description="Learn about SarkariNaukriRajasthan.com – a free platform providing latest Rajasthan government job notifications, sarkari results, and admit cards."
      path="/about"
    />
    <h1 className="static-page-title">About Us</h1>

    <section className="static-section">
      <h2>Who We Are</h2>
      <p>
        <strong>SarkariNaukriRajasthan.com</strong> is a dedicated platform for job seekers looking
        for the latest government job opportunities in Rajasthan and across India. We provide
        up-to-date information on Central Government, State Government, Banking, Railway, Defence,
        and PSU job vacancies.
      </p>
    </section>

    <section className="static-section">
      <h2>Our Mission</h2>
      <p>
        Our mission is to make government job information accessible and organized for every
        Indian citizen. We believe that finding the right sarkari naukri should be simple,
        transparent, and free for everyone.
      </p>
    </section>

    <section className="static-section">
      <h2>What We Offer</h2>
      <ul>
        <li><strong>Latest Job Notifications:</strong> Timely updates on new government job openings across all sectors.</li>
        <li><strong>Category-wise Listings:</strong> Jobs organized by sector – Central Govt, State Govt, Banking, Railway, Defence, and PSU.</li>
        <li><strong>Qualification-based Search:</strong> Find jobs matching your qualification – 10th pass, 12th pass, Graduate, Post Graduate, Diploma, B.Tech, B.Com, B.Sc, and CA/ICWA.</li>
        <li><strong>Important Dates & Links:</strong> Application deadlines, admit card dates, and direct links to official portals.</li>
        <li><strong>Free Access:</strong> All information on our website is completely free to access.</li>
      </ul>
    </section>

    <section className="static-section">
      <h2>Why Trust Us?</h2>
      <p>
        We source all job information directly from official government notifications and
        recruitment websites. Our team regularly verifies and updates listings to ensure accuracy.
        We do not charge any fees for job information or applications – we only provide links to
        official sources.
      </p>
    </section>

    <section className="static-section">
      <h2>Our Values</h2>
      <ul>
        <li><strong>Accuracy:</strong> We verify every job listing against official sources.</li>
        <li><strong>Timeliness:</strong> We publish new notifications as soon as they are released.</li>
        <li><strong>Accessibility:</strong> Our website is designed to work on all devices, with Hindi translation support.</li>
        <li><strong>Transparency:</strong> We clearly link to official sources so you can verify information yourself.</li>
      </ul>
    </section>

    <section className="static-section">
      <h2>Contact</h2>
      <p>
        Have questions or suggestions? Reach out to us at{' '}
        <a href="mailto:sarkarinaukrirajasthanjobs@gmail.com">sarkarinaukrirajasthanjobs@gmail.com</a>
      </p>
    </section>
  </div>
);

export default AboutPage;
